"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _miniDealerLocator = _interopRequireDefault(require("./mini-dealer-locator.css"));
var _defs, _g;
var roundHalf = function roundHalf(num) {
  return Math.round(num * 2) / 2;
}; // eslint-disable-line

var checkFillAmount = function checkFillAmount(fill) {
  if (fill === 'fill') {
    return 'black';
  }
  if (fill === 'half') {
    return 'url(#halfGradient)';
  }
  return 'none';
};
var Star = function Star(_ref) {
  var fill = _ref.fill;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xlink: "http://www.w3.org/1999/xlink",
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    version: "1.1"
  }, _defs || (_defs = /*#__PURE__*/_react["default"].createElement("defs", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("linearGradient", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "halfGradient"
  }, /*#__PURE__*/_react["default"].createElement("stop", {
    stopOpacity: "1",
    offset: "50%",
    stopColor: "#000"
  }), /*#__PURE__*/_react["default"].createElement("stop", {
    stopOpacity: "0",
    offset: "50%"
  })))), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Dealer-Locator",
    stroke: "none",
    strokeWidth: "1",
    fill: checkFillAmount(fill),
    fillRule: "evenodd"
  }, _g || (_g = /*#__PURE__*/_react["default"].createElement("g", {
    id: "Desktop_Find_A_Dealership_1.1",
    transform: "translate(-209.000000, -461.000000)",
    fillRule: "nonzero",
    stroke: "#000"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "HOVER/TAP-STATES"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "RESULTS",
    transform: "translate(0.000000, 212.000000)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Dealer",
    transform: "translate(0.000000, 202.000000)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Star-Rating",
    transform: "translate(140.000000, 47.000000)"
  }, /*#__PURE__*/_react["default"].createElement("polygon", {
    id: "Shape",
    points: "76.2733333 0.256 74.0813333 4.696 69.1826667 5.408 72.728 8.864 71.8906667 13.744 76.2733333 11.44 80.6546667 13.744 79.8186667 8.864 83.364 5.408 78.464 4.696"
  })))))))));
};
var makeStarRefArray = function makeStarRefArray(rating) {
  var starSetupArr = [];
  var star = rating;
  var starsArrayLength = 5;
  for (var i = 0; i < starsArrayLength; i += 1) {
    if (star >= 1) {
      starSetupArr = [].concat(starSetupArr, ['fill']);
      // eslint-disable-next-line
    } else if (star === 0.5) {
      starSetupArr = [].concat(starSetupArr, ['half']);
    } else {
      starSetupArr = [].concat(starSetupArr, ['empty']);
    }
    star -= 1;
  }
  return starSetupArr;
};
var StarRating = function StarRating(_ref2) {
  var rating = _ref2.rating;
  var roundedRating = roundHalf(rating);
  var starFills = makeStarRefArray(roundedRating);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _miniDealerLocator["default"].starContainer
  }, starFills.map(function (fill, i) {
    return /*#__PURE__*/_react["default"].createElement(Star, {
      key: i.toString(),
      fill: fill
    });
  }));
};
var _default = StarRating;
exports["default"] = _default;